import request from '@/config/axios'

export const getChannelList = () => request.get({ url: '/rental/home/channel/list' })
export const getChannel = (id: number) => request.get({ url: '/rental/home/channel/get', params: { id } })
export const createChannel = (data: any) => request.post({ url: '/rental/home/channel/create', data })
export const updateChannel = (data: any) => request.put({ url: '/rental/home/channel/update', data })
export const deleteChannel = (id: number) =>
  request.delete({ url: '/rental/home/channel/delete', params: { id } })
